import React from "react";
import styles from "./OnboardingStage.module.css";

const getStatusPalette = (value = "") => {
  const normalized = String(value || "").toLowerCase();
  if (normalized.includes("connected")) {
    return { border: "#16a34a", bg: "#dcfce7", text: "#14532d" };
  }
  if (normalized.includes("pending")) {
    return { border: "#d97706", bg: "#fef3c7", text: "#92400e" };
  }
  return { border: "#cbd5f5", bg: "#e0e7ff", text: "#1e1b4a" };
};

const GoogleStack = ({ title = "Google Stack", statuses = [], summary = "" }) => {
  if (!statuses.length && !summary) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{title}</h3>

      {statuses.length > 0 ? (
        <div className={styles.card}>
          <div className={styles.sectionHeader}>
            <span>G</span>
            <span className={styles.sectionLabel}>Connection Status</span>
          </div>
          <div className={styles.statusGrid}>
            {statuses.map((item, index) => {
              const palette = getStatusPalette(item.value);
              return (
                <div
                  key={`${item.key}-${index}`}
                  className={styles.statusPill}
                  style={{ borderColor: palette.border, backgroundColor: palette.bg }}
                >
                  <span className={styles.statusLabel} style={{ color: palette.text }}>
                    {item.key}
                  </span>
                  <span className={styles.statusValue} style={{ color: palette.text }}>
                    {item.value}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default GoogleStack;
